import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import PermissionService from '../services/PermissionService';
import RoleService from '../services/RoleService';

const initialState = {
  data: [],
  datas: [],
  missingRoles: [],
  formError: [],
  meta: {
    current_page: 1,
    per_page: 10,
    last_page: 10,
    total: 10,
  },
  error: null,
  status: '',
  dataLoading: false,
  submitLoading: false,

  isOpenRoleDialog: false,
};

export const fetchRoleList = createAsyncThunk(
  'role/fetchRoleList',
  async (data) => {
    try {
      const resp = await RoleService.FetchRoleList(data);
      return resp;
    } catch (error) {
      return error.response.data;
    }
  },
);

export const createRole = createAsyncThunk('role/createRole', async (data) => {
    const response = await RoleService.CreateRole(data);
    return response;
});

export const updateRole = createAsyncThunk('role/updateRole', async (data) => {
    const response = await RoleService.UpdateRole(data);
    return response;
});

export const deleteRole = createAsyncThunk('role/deleteRole', async (data) => {
  const response = await RoleService.DeleteRole(data);
  return response;
});

const roleSlice = createSlice({
  name: 'role',
  initialState: initialState,
  reducers: {
    openRoleDialog: (state, action) => {
      state.isOpenRoleDialog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchRoleList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data.data?.existing_roles];
          state.missingRoles = [...action.payload?.data.data?.missing_roles];
          state.pagination = action.payload?.data.page;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchRoleList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(createRole.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.datas = [...action.payload?.data.data?.existing_roles];
        state.missingPermissions = [...action.payload?.data.data?.missing_roles];
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
        toast.success(action.payload?.data.message);
      })
      .addCase(createRole.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
        toast.error('Failed to create role');
      })
      .addCase(updateRole.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.datas = [...action.payload?.data.data?.existing_roles];
        state.missingPermissions = [...action.payload?.data.data?.missing_roles];
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
        toast.success(action.payload?.data.message);
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
        toast.error('Failed to update role');
      })
      .addCase(deleteRole.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.status = '';
        state.datas = [...action.payload?.data.data?.existing_roles];
        state.missingPermissions = [...action.payload?.data.data?.missing_roles];
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
        state.isOpenRoleDialog = false;
        toast.success(action.payload?.data.message);
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
        toast.error('Failed to delete role');
      });
  },
});

const { reducer } = roleSlice;

export const { openRoleDialog } = roleSlice.actions;

export const roleSelector = (state) => state?.role;

export default reducer;
